// Helper: get the short, public-facing name for a user.
// - If `user.public_name` is set by the user, use it.
// - Otherwise, auto-derive from `user.name` (first given name + first family name).
// The backend already ships `public_name` on `/auth/me` and `serialize_user`; this
// helper is a safe frontend fallback for any legacy payload that only has `name`.
export function getPublicName(user) {
    if (!user) return "";
    if (user.public_name && String(user.public_name).trim()) return String(user.public_name).trim();
    return derivePublicName(user.name || "");
}

export function derivePublicName(fullName) {
    const tokens = String(fullName || "").trim().split(/\s+/).filter(Boolean);
    if (tokens.length === 0) return "";
    if (tokens.length === 1) return tokens[0];
    if (tokens.length === 2) return `${tokens[0]} ${tokens[1]}`;
    if (tokens.length === 3) return `${tokens[0]} ${tokens[2]}`;
    // 4+ tokens: skip common ES connectors when picking the family name.
    const connectors = new Set(["de", "del", "la", "las", "los", "y"]);
    for (let i = tokens.length - 2; i > 0; i--) {
        if (!connectors.has(tokens[i].toLowerCase())) return `${tokens[0]} ${tokens[i]}`;
    }
    return `${tokens[0]} ${tokens[tokens.length - 1]}`;
}
